module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2dZbi"))).then(() => parcelRequire('2KbAe'));